// extracted by mini-css-extract-plugin
export default {"root":"FEdVa83007A05wV4kU1V","add-button":"scWLwern5Iu1JuOibR5A","drivers-list":"TisgRuBlov8ATcZyDN5f","driver-item":"ZHJzUNauhYuaWkkPoclU"};